import { render, staticRenderFns } from "./PartsTable.vue?vue&type=template&id=b954eea0&scoped=true&lang=pug"
import script from "./PartsTable.vue?vue&type=script&lang=js"
export * from "./PartsTable.vue?vue&type=script&lang=js"
import style0 from "./PartsTable.vue?vue&type=style&index=0&id=b954eea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b954eea0",
  null
  
)

export default component.exports